import * as yup from 'yup';

export const createSuggestionSchema = yup.object().shape({
  suggestion_title: yup.string().required('É necessário informar um título.'),
  suggestion_description: yup.string().required('É necessário informar uma descrição.'),
});
